/* CDH helper js - include custom format functions an other help js functions */
(function ($) {
    var __cnt = 0;
    var seed = function () {
        var rnd = function () {
            return Math.round(Math.random() * 4294967295).toString(36);
        };
        return 's' + Date.now().toString(36) + rnd() + rnd() + rnd();
    };

    var helper = {
        getUniqueID: function (prefix) {
            return prefix + (__cnt++) + seed();
        },
        // parse currency values
        parseCurrency: function (x) {
            var result = {
                negative: false,
                beforeDot: '--',
                afterDot: '--'
            };

            var val = parseFloat(x);

            if (!isNaN(val)) {
                result.negative = val < 0;
                var parts = Math.abs(val).toFixed(2).split(".");
                result.beforeDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                result.afterDot = parts[1];
            }

            return result;
        },

        htmlFormatAmount: function(amount) {
            if (amount === 0) {
                return "<span>$0.00</span>";
            }

            let currency = $.cdh.helper.parseCurrency(amount);
            let result = '$' + currency.beforeDot + '.' + currency.afterDot;
            if (currency.negative) {
                result = "(" + result + ")";
            }

            return result;
        },
        
        formatAmount: function(amount) {
            if (amount === 0) {
                return "$0.00";
            }

            let currency = $.cdh.helper.parseCurrency(amount);

            let result = '$' + currency.beforeDot + '.' + currency.afterDot;
            if (currency.negative) {
                result = "(" + result + ")";
            }

            return result;
        },

        //get url parameter by name
        urlParam: function (name) {
            var match = RegExp('[?&]' + name + '=([^&]*)')
                .exec(window.location.search);
            return match ?
                decodeURIComponent(match[1].replace(/\+/g, ' '))
                : null;
        },
        
        setUrlParam: function (name, value) {
            let search = window.location.search;
            if (search && search.includes(name)) {
                let regex = new RegExp(`${name}=([^&]+)`);
                search = search.replace(regex, `${name}=${value}`);
            } else {
                search = search ? search + '&' : '?';
                search = `${search}${name}=${value}`;
            }
            let resultUrl = window.location.origin + window.location.pathname + search;
            window.history.replaceState({}, document.title, resultUrl);
        },

        deleteUrlParam: function (name) {
            let search = window.location.search;
            if (search && search.includes(name)) {
                let regex = new RegExp(`[?&]${name}=[^&]+`);
                search = search.replace(regex, '');
                if (search.startsWith('&')) {
                    search = '?' + search.slice(1);
                }
                let resultUrl = window.location.origin + window.location.pathname + search;
                window.history.replaceState({}, document.title, resultUrl);
            }
        },
        
        anchorParam: function (name) {
            let anchors = window.location.hash;
            let match = RegExp('[#&]' + name + '=([^&]*)').exec(anchors);
            return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
        },
        
        setAnchorParam: function (name, value) {
            let anchors = window.location.hash;
            if (anchors && anchors.includes(name)) {
                let regex = new RegExp(`(?<=${name}=)([^&]+)`);
                window.location.hash = anchors.replace(regex, value)
            } else {
                anchors = anchors ? anchors + '&' : '';
                window.location.hash = `${anchors}${name}=${value}`;
            }
        },

        hasPermission: function (permission) {
            var accessRights = parseInt($.cdh.accessRights);
            return accessRights == (accessRights | permission);
        },

        hasFlag: function(value, flagsValue) {
            var flags = parseInt(flagsValue);
            return flags == (flags | value);
        },

        hasEnumValue: function (value, enumType) {        
            for (var name in enumType) {
                if (enumType[name] === value)
                    return true;
            }

            return false;
        },


        dateNowString: function () {
            return moment().format("MMM D, YYYY").valueOf();
        },

        getCurrentMonth: function (monthtype) {
            var todayDate = new Date();
            return todayDate.toLocaleString('en-US', { month: monthtype });
        },

        getCurrentQuarter: function () {
            var todayDate = new Date();
            return ('Q' + Math.floor((todayDate.getMonth() + 3) / 3));
        },

        getCurrentYear: function () {
            var todayDate = new Date();
            return todayDate.getFullYear();
        },

        getCurrentQuarterDates: function () {
            var todayDate = new Date();
            var quarter = Math.floor((todayDate.getMonth() + 3) / 3) - 1;
            var firstDate = new Date(todayDate.getFullYear(), quarter * 3, 1);
            var endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);
            var result = moment(firstDate).format("MM/DD/YYYY") + ' - ' + moment(endDate).format("MM/DD/YYYY");
            return result;
        },

        dateNowDatePlusDaysString: function (days) {
            return moment.utc().startOf('day').add(days, 'day').format();
        },

        dateNowStringWithFormat: function(format) {
            return moment().format(format).valueOf();
        },    

        camelCaseTitle: function (value) {
            return value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
        },  

        getObjectFromLocalStorage: function (key) {
            try {
                var obj = localStorage.getItem(key);
                if (obj) {
                    var values = obj.split(";");
                    if (new Date(values[1]) < new Date()) {
                        removeObjectFromLocalStorage(key);
                        return null;
                    }

                    return JSON.parse(Base64.decode(values[0]));
                }

                return null;
            } catch (e) {
                return null;
            }
        },

        setObjectToLocalStorage: function (key, object, storeTimeInMin) {
            var min = 15;
            if (storeTimeInMin) {
                min = storeTimeInMin;
            }

            var values = new Array();
            var expirationDate = new Date();
            expirationDate.setMinutes(expirationDate.getMinutes() + min);

            values.push(Base64.encode(JSON.stringify(object)));
            values.push(expirationDate);

            try {
                localStorage.setItem(key, values.join(";"));
            }
            catch (e) { }
        },
        
        removeObjectFromLocalStorage: function (key) {
            try {
                localStorage.removeItem(key);
            } catch (e) {
            }
        },
        htmlToPlainText: function (text) {
            if (!text) return text;
            var regex = /(&nbsp;|<([^>]+)>)/ig;
            var result = text.replace(regex, "");
          
            return this.decodeHtml(result);
        },
        decodeHtml: function (html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },

        alert: function (msg, okCallback, cancelCallback, title, buttonName, styleParam) {
            //Obsolete, use alert2 instead because alert2 can handle if it's displayed inside popup to not override popup content
            var twoButtons = typeof okCallback === 'function';
            var closeButton = $.cdh.languageConstant.getConstant('button.close');
            var closeEscButton = $.cdh.languageConstant.getConstant('button.close-esc');
            var OkButton = $.cdh.languageConstant.getConstant('button.ok');
            var cancelButton = $.cdh.languageConstant.getConstant('button.cancel');
            if (buttonName) closeButton = buttonName;  

            var tpl_btn = twoButtons
                ? '<button type="button" class="button button-cancel js-cancel"><span class="btn__text">' + cancelButton + '</span></button>' +
                '<button type="submit" class="button button-subm js-ok"><span class="btn__text">' + OkButton + '</span></button > '
                : '<button type="submit" class="button button-subm js-cancel"><span class="btn__text">' + closeButton + '</span></button>';


            var alertTitle = $.cdh.languageConstant.getConstant('title.warning');
            if (title) {
                alertTitle = title;
            }
            var style = "";
            if(styleParam)
                style = styleParam;
            
            var tpl =
                '<div class="popup-form alert-popup-container magnific-popup-container ' + (closeButton.length ? 'mfp-close-btn-in' : '') + '">' +
                     '<div class="popup-form_title">' +
                         '<h1 class="popup-form_title-inner" id="popup-form_title-inner">' +
                             alertTitle +
                '</h1>' +
                '<button title='+ closeEscButton + 'type="button" class="mfp-close" aria-label="close">×</button>' +
                     '</div>' +
                     '<div class="popup-form_content">' +
                         '<div class="popup-form_wrap">' +
                             '<div class="mark-card">' +
                                 '<p style='+ style +'>' + msg + '</p>' +
                             '</div>' +
                         '</div>' +
                         '<div class="popup_buttons buttons-order popup_buttons--flex">' + tpl_btn + '</div>' +
                     '</div>' +
                 '</div>';

            function addOnOpenEvents(context) {
                var that = context;
                $('div.mfp-wrap').attr('role', 'dialog').attr('aria-modal', 'true').attr('aria-labelledby', 'popup-form_title-inner');
                $(that.contentContainer).find('.js-cancel').click( function() {
                    that.close();
                    if (typeof cancelCallback === 'function') {
                        cancelCallback();
                    }
                });
                $(that.contentContainer).find('.js-ok').click( function() {
                    that.close();
                    if (typeof okCallback === 'function') {
                        okCallback();
                    }
                });
                if ($.cdh.isMobile) {
                    $('body').addClass('mfp-alert-popup');
                    $('div.mfp-wrap').insertAfter($('header.header'));
                    window.scrollTo(0, 0);
                }
            }
            
            $.magnificPopup.open({
                enableEscapeKey: false,
                closeOnBgClick: false,
                items: {
                    src: '<div>' + tpl + '</div>',
                    type: 'inline'
                },
                //closeOnBgClick: false,
                modal: true,
                callbacks: {
                    open: function () {
                        addOnOpenEvents(this);
                    },
                    change: function() {
                        if (this.isOpen) {
                            addOnOpenEvents(this);
                        }
                    },
                    close: function () {
                        if ($.cdh.isMobile) {
                            $('body').removeClass('mfp-alert-popup');
                        }
                    }
                }
            });
        },
        
        alert2: function(settings){
            if(!settings)
                settings = {};

            var closeEscButton = $.cdh.languageConstant.getConstant('button.close-esc');
            var title = settings.title !== undefined ? this.htmlDecode(settings.title) : $.cdh.languageConstant.getConstant('title.warning');
            var titleVisible = settings.titleVisible !== undefined ? settings.titleVisible : true;
            var okVisible = settings.okVisible !== undefined ? settings.okVisible : true;
            var okText = settings.okText !== undefined ? settings.okText : $.cdh.languageConstant.getConstant('button.ok');
            var customClass = settings.customClass !== undefined ? settings.customClass : '';
            var okCallback = settings.okCallback !== undefined ? settings.okCallback: function() {};
            var okCssClass = settings.okCssClass !== undefined ? settings.okCssClass : 'button-subm';
            var okAttrs = settings.okAttrs !== undefined ? settings.okAttrs : {};
            var cancelVisible = settings.cancelVisible !== undefined ? settings.cancelVisible : true;
            var cancelText = settings.cancelText !== undefined ? settings.cancelText : $.cdh.languageConstant.getConstant("button.cancel");
            var cancelCallback = settings.cancelCallback !== undefined ? settings.cancelCallback : function() {};
            var message = settings.message !== undefined ? settings.message : title;
            var buttonsBlockCssClass = settings.buttonsBlockCssClass !== undefined ? settings.buttonsBlockCssClass : '';
            var hasCloseBtn = settings.hasCloseBtn !== undefined ? settings.hasCloseBtn : false;
            var isImpersonated = settings.isImpersonated !== undefined ? settings.isImpersonated : false;
            if(!okVisible && !cancelVisible) {
                okVisible = true;
                okText = $.cdh.languageConstant.getConstant('button.close');
            }
            
            var popupVisible = $(".magnific-popup-container").is(":visible");
            if(popupVisible && !$.cdh.isMobile) {

                var btns = '';
                if(cancelVisible){
                    btns += '<button type="submit" class="button button-cancel js-cancel"><span class="btn__text">' + cancelText + '</span></button>'
                }
                if(okVisible){
                    btns += '<button type="submit" class="button ' + okCssClass + ' js-ok"><span class="btn__text" title="' + okText + '">' + okText + '</span></button>';
                }

                var closeButton = '';
                if (hasCloseBtn === true) {
                    closeButton = '<button title=' + closeEscButton + 'type="button" class="popup-usual-close-btn" aria-label="close">×</button>';
                }
                var impersonationMsg = '';
                if (isImpersonated === true) {
                    impersonationMsg = '<div class="popup-form_error-title" role="alert"><span aria-live="assertive">This operation is not allowed under impersonation</span></div>';
                }

                var titleDisplayState = titleVisible ? '' : 'display: none';
                var alertBody =
                    '<div id="alert-message"><div class="popup-usual-bg"></div>' +
                    '<div class="popup-usual-wrapper">' +
                        '<div class="popup-usual-container">' +
                            '<div class="popup-usual-inner">' +
                    '<div class="popup-usual-content-block">' +
                    '<div class="popup-usual-title" style="' + titleDisplayState + '">' + title + '</div>' + impersonationMsg+
                                    '<div class="popup-usual-content clearfix">' +
                                        message +
                                        '<div class="popup_buttons popup_buttons--flex ' + buttonsBlockCssClass + ' buttons-order">' + btns + '</div>' +
                                    '</div>' +
                                    closeButton +
                                '</div></div></div></div></div>';
                
                $(".main-content").prepend(alertBody);

                $(".main-content").find('.js-cancel').click(function(){
                    $("#alert-message").remove();
                    if (typeof cancelCallback === 'function') {
                        cancelCallback();
                    }
                });

                $(".main-content").find('.js-ok').click(function(){
                    $("#alert-message").remove();
                    if (typeof okCallback === 'function') {
                        okCallback();
                    }
                });
            }else{
                var btns = '';
                if(cancelVisible){
                    btns += '<button type="submit" class="button button-cancel js-cancel"><span class="btn__text">' + cancelText + '</span></button>'
                }
                
                if (okVisible) {
                    btns += '<button type="submit" class="button ' + okCssClass + ' js-ok"><span class="btn__text" title="' + okText + '">' + okText + '</span></button>';
                }

                var closeButton = '';
                if (hasCloseBtn === true) {
                    closeButton = '<button title=' + closeEscButton + 'type = "button" class="mfp-close" aria - label="close" >×</button > ';
                }
                var impersonationMsg = '';
                if (isImpersonated === true) {
                    impersonationMsg = '<div class="popup-form_error-title" role="alert"><span aria-live="assertive">This operation is not allowed under impersonation</span></div>';
                }
                var titleDisplayState = titleVisible ? '' : 'display: none';
                var alertBody =
                    '<div class="popup-form alert-popup-container magnific-popup-container ' + ((customClass != '') ? customClass : '') + (closeButton.length ? 'mfp-close-btn-in' : '') + '">' +
                        '<div class="popup-form_title" style="' + titleDisplayState + '">' +
                    '<h1 class="popup-form_title-inner" id="popup-form_title-inner">' + title + '</h1>' +
                    closeButton +
                    '</div>' + impersonationMsg+
                        '<div class="popup-form_content">' +
                            '<div class="popup-form_wrap">' +
                                '<div class="mark-card">' +
                                    '<p id="popup-form_msg">' + message + '</p>' +
                                '</div>' +
                            '</div>' +
                            '<div class="popup_buttons popup_buttons--flex ' + buttonsBlockCssClass + ' buttons-order">' + btns + '</div>' +
                        '</div>' +
                    '</div>';

                function addOnOpenEvents(context) {
                    var that = context;
                    $('div.mfp-wrap').attr('role', 'alertdialog').attr('aria-modal', 'true').attr('aria-labelledby', 'popup-form_title-inner').attr('aria-describedby', 'popup-form_msg');

                    var okBtn = $(that.contentContainer).find('.js-ok');
                    var cancelBtn = $(that.contentContainer).find('.js-cancel');
                    cancelBtn.click( function() {
                        that.close();
                        if (typeof cancelCallback === 'function') {
                            cancelCallback();
                        }
                    });
                    okBtn.click( function() {
                        that.close();
                        if (typeof okCallback === 'function') {
                            okCallback();
                        }
                    });
                    for (var i in okAttrs) {
                        okBtn.attr(i, okAttrs[i]);                       
                        if (i === 'role' && okAttrs[i] === 'link') {
                            okBtn.keydown(function(e) {
                                if (e.keyCode === 32) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
                            });
                        }
                    }
                    if ($.cdh.isMobile) {
                        $('body').addClass('mfp-alert-popup');
                        $('div.mfp-wrap').insertAfter($('header.header'));
                        window.scrollTo(0, 0);
                    }
                }

                $.magnificPopup.open({
                    enableEscapeKey: false,
                    closeOnBgClick: false,
                    items: {
                        src: '<div>' + alertBody + '</div>',
                        type: 'inline'
                    },
                    modal: true,
                    callbacks: {
                        open: function () {
                            addOnOpenEvents(this);
                        },
                        change: function() {
                            if (this.isOpen) {
                                addOnOpenEvents(this);
                            }
                        },
                        close: function () {
                            if ($.cdh.isMobile) {
                                $('body').removeClass('mfp-alert-popup');
                            }
                        }
                    }
                });
            }
        },

        showPdfViwer: function(url) {
            var body = $('body');

            // build unique viewer id
            var uniqueId = 'pdf_viewer_' + url.replace(/[^a-zA-Z0-9]+/g, '');

            // set body overflow
            body.addClass('pdf-viewer-opened');

            // show existing pdf viewer
            var existingPdfViewer = $('#' + uniqueId);
            if (existingPdfViewer.length) {
                existingPdfViewer.removeClass('hidden');
                return;
            }

            // add new pdf viewer
            var pdfViewer = $('<div/>', {
                id: uniqueId,
                class: 'pdf-viewer',
                html: '<iframe src="' + url + '" class="pdf-viewer_iframe" allowfullscreen webkitallowfullscreen></iframe>' +
                      '<button type="button" class="pdf-viewer_close-btn icon-wcp-icons-font_cancel"></button>' +
                      '<button type="button" class="pdf-viewer_print-btn icon-wcp-icons-font_arrowdown"></button>'
            }).appendTo(body);

            // add close button click event
            pdfViewer.find('button.pdf-viewer_close-btn').on('click', function() {
                $(this).closest('div.pdf-viewer').addClass('hidden');
                body.removeClass('pdf-viewer-opened');
            });

            //Add download button
            pdfViewer.find('button.pdf-viewer_print-btn').on('click', function() {
                window.open(url.replace('/Scripts/pdf-viewer-js/ViewerJS/#', ''),'_blank');
            });
        },

        // show fancybox loader
        showFancyboxLoader: function() {
            var body = $('body');

            // show fancybox overlay
            $('<div/>', {
                class: 'fancybox-overlay fancybox-overlay-fixed',
                css: {
                    'display': 'block',
                    'width': 'auto',
                    'height': 'auto'
                }
            }).appendTo(body);

            // show fancybox loader
            $('<div/>', {
                id: 'fancybox-loading',
                html: '<div></div>'
            }).appendTo(body);
        },

        // hide fancybox loader
        hideFancyboxLoader: function() {
            $('div.fancybox-overlay').remove();
            $('#fancybox-loading').remove();
        },

        maxDocumentSize: function () {
            return $.cdh.const.maxDocumentSizeMb;
        },

        confirm: function(msg, okCallback, cancelCallback, title) {
            this.alert(msg, okCallback, cancelCallback, title);
        },
        
        delete: function(settings) {
            settings.okText = $.cdh.languageConstant.getConstant("button.delete");
            settings.okCssClass = 'button-delete';
            this.alert2(settings);
        },

        waitAlert: function (msg, title) {
            var alertTitle = title || $.cdh.languageConstant.getConstant("profile.please-wait");
            var tpl = '<div class="popup-contrib popup-wait-alert magnific-popup-container">' +
                          '<div class="popup-form_title">' +
                              '<h1 class="popup-form_title-inner" id="popup-form_title-inner">' + alertTitle + '</h1>' +
                          '</div>' +
                          '<div class="popup-form_content">' +
                             '<p>' + msg + '</p>' +
                             '<div class="wait-alert-hidden-field-box">' +
                                 '<input type="text" id="wait_alert_hidden_field">' + // need for removing focus from previous focused element
                             '</div>' +
                          '</div>' +
                      '</div>';

            function addOnOpenEvents() {
                var body = $('body');
                body.addClass('mfp-wait-alert-popup');
                $('div.mfp-wrap').attr('role', 'dialog').attr('aria-modal', 'true').attr('aria-labelledby', 'popup-form_title-inner');
                if ($.cdh.isMobile) {
                    body.addClass('mfp-alert-popup');
                    $('div.mfp-wrap').insertAfter($('header.header'));
                    window.scrollTo(0, 0);
                } else {
                    body.addClass('overflow-hidden');
                }

                var waitAlertHiddenField = $('#wait_alert_hidden_field');
                if (waitAlertHiddenField.length) {
                    waitAlertHiddenField.keydown(function(e) {
                        if ($.inArray(e.keyCode, [9, 13, 27, 37, 38, 39, 40]) !== -1) {
                            return false;
                        }
                    });
                    setTimeout(function() { // need for MagnificPopup (it waits for the animation ending)
                        waitAlertHiddenField.focus();
                    }, 100);
                }
            }

            $.magnificPopup.open({
                enableEscapeKey: false,
                closeOnBgClick: false,
                items: {
                    src: '<div>' + tpl + '</div>',
                    type: 'inline'
                },
                autoFocusLast: false,
                modal: true,
                callbacks: {
                    open: function () {
                        addOnOpenEvents();
                    },
                    change: function() {
                        if (this.isOpen) {
                            addOnOpenEvents();
                        }
                    },
                    close: function () {
                        var body = $('body');
                        body.removeClass('mfp-wait-alert-popup');
                        if ($.cdh.isMobile) {
                            body.removeClass('mfp-alert-popup');
                        } else {
                            body.removeClass('overflow-hidden');
                        }
                    }
                }
            });
        },

        closePopup: function() {
            $.magnificPopup.close();
        },
     
        logout: function () {

            $("#logout-form").submit();
            
                $.cdh.languageConstant.changeLanguage('en');
                removeChatHistory();
            
        },

        logoutWithRedirect: function(urlToRedirect){
            var logOffRequest = new $.cdh.post.authentication.logOff();
            logOffRequest.load()
                .done(function () {
                    
                        $.cdh.languageConstant.changeLanguage('en');
                    removeChatHistory();
                    
                    window.location.replace(urlToRedirect);
                });
        },
        
        logoutWithMessage: function(message){
            var logOffRequest = new $.cdh.post.authentication.logOff();
            logOffRequest.load()
                .done(function () {
                    if(message){
                        alert(message);
                    }
                    
                        removeChatHistory();
                        window.location.replace($.cdh.routes.authentication.handshake());
                    
                });
        },

        ieBrowser: function () {
            return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
        },

        navigate: function (url) {
            window.navigate = url;
        },

        rebuildAlertTables: function (alertBody) {

            // get tables
            //var regExp = /<table[\s\S]+?class=\"mbi_box[\s\S]*?\"[\s\S]*?\>[\s\S]+?mbi_text_underline[\s\S]+?<\/table\>/ig;
            var regExp = /<table.+?class=\"mbi_box\".*?\>[\s\S]+?<\/table\>/ig;
            var tablesArr = alertBody.match(regExp);

            // exit if alert body has no tables
            if (tablesArr === null) {
                return alertBody;
            }

            // class names
            var className = {
                titleOriginal: 'mbi_text_underline',
                titleReplacement: 'mbi_text_bold'
            };

            // cycle by tables
            for (var i = 0, lenTables = tablesArr.length; i < lenTables; i++) {
                var table = tablesArr[i];

                var tableNew = '';
                var regExpTr = /<tr[\s\S]*?\>[\s\S]+?<\/tr\>/ig;
                var regExpTd = /<td[\s\S]+?<\/td\>/ig;
                var trsArr = table.match(regExpTr);
                var tdsFromFirstTrArr = trsArr[0].match(regExpTd);

                // added classes for tds without them
                if (table.search(className.titleOriginal) === -1) {
                    if (tdsFromFirstTrArr.length <= 3) {
                        continue;
                    }

                    for (var j = 0, lenTdsFromFirstTrArr = tdsFromFirstTrArr.length; j < lenTdsFromFirstTrArr; j++) {
                        var td = tdsFromFirstTrArr[j];
                        var tdOpeningTag = td.match(/<td[\s\S]*?\>/i);
                        if (tdOpeningTag === null || tdOpeningTag.length === 0) {
                            continue;
                        }
                        if (tdOpeningTag[0].search(' class=') === -1) {
                            var tdNew = td.replace(/<td/ig, '<td class=\"' + className.titleOriginal + '\"');
                            tdsFromFirstTrArr[j] = tdsFromFirstTrArr[j].replace(td, tdNew);
                            trsArr[0] = trsArr[0].replace(td, tdNew);
                        }
                    }
                }

                // set headers (parse first tr)
                var titlesArr = [];
                var isAllTdsFromFirstTrHaveTitleClass = true;
                for (var j = 0, lenTdsFromFirstTrArr = tdsFromFirstTrArr.length; j < lenTdsFromFirstTrArr; j++) {
                    var td = tdsFromFirstTrArr[j];
                    if (td.search(className.titleOriginal) === -1) {
                        isAllTdsFromFirstTrHaveTitleClass = false;
                        continue;
                    }
                    td = td.replace(className.titleOriginal, className.titleReplacement);
                    titlesArr.push(td);
                }

                // check vertical titles existence (parse second tr)
                var isSomeTdsFromSecondTrHaveTitleClass = false;
                if (trsArr.length > 1) {
                    var tdsFromSecondTrArr = trsArr[1].match(regExpTd);
                    for (var j = 0, lenTdsFromSecondTrArr = tdsFromSecondTrArr.length; j < lenTdsFromSecondTrArr; j++) {
                        var td = tdsFromSecondTrArr[j];
                        if (td.search(className.titleOriginal) !== -1) {
                            isSomeTdsFromSecondTrHaveTitleClass = true;
                            continue;
                        }
                    }
                }

                if (!isAllTdsFromFirstTrHaveTitleClass || isSomeTdsFromSecondTrHaveTitleClass) {
                    continue;
                }

                // cycle by trs
                for (var j = 1, lenTrsArr = trsArr.length; j < lenTrsArr; j++) {
                    var tableFromTr = '<table class="mbi_box';
                    if (lenTrsArr > 2) {
                        tableFromTr += ' mbi_box_with_border';
                    }
                    tableFromTr += '">\r\n';
                    var tr = trsArr[j];
                    var tdsArr = tr.match(regExpTd);

                    // cycle by tds
                    for (var n = 0, lenTdsArr = tdsArr.length; n < lenTdsArr; n++) {
                        var td = tdsArr[n];
                        tableFromTr += '\t<tr>\r\n' +
                                '\t\t' + titlesArr[n] + '\r\n' +
                                '\t\t' + td + '\r\n' +
                            '\t</tr>\r\n';
                    }
                    tableFromTr += '</table>\r\n';

                    // replace empty previous email td
                    if (tableFromTr.search('Previous Email Address') !== -1) {
                        var regExpPrevEmail = /(Previous\sEmail\sAddress[\s\S]+?<td[\s\S]+?\>)([\s\S]*?)(<\/td\>)/ig;
                        var prevEmailArr = regExpPrevEmail.exec(tableFromTr);
                        if (prevEmailArr.length >= 4) {
                            var prevEmailValue = prevEmailArr[2];
                            prevEmailValue = prevEmailValue.replace(/[\s\n\r\t]*/gi, '');
                            if (prevEmailValue === '') {
                                tableFromTr = tableFromTr.replace(regExpPrevEmail, '$1' + '-' + '$3');
                            }
                        }
                    }

                    tableNew += tableFromTr;
                }

                // replace table
                alertBody = alertBody.replace(table, tableNew);
            }

            return alertBody;
        },

        // addThTags: function(str) {
        //     var regExpTbls = /<table[\s\S]+?<\/table\>/ig;
        //     var tablesArr = str.match(regExpTbls);
        //     if (tablesArr === null) {
        //         return str;
        //     }

        //     var regExpTblOpeningTag = /<table[\s\S]*?\>/i;
        //     var regExpTr = /<tr[\s\S]*?\>[\s\S]+?<\/tr\>/ig;
        //     var regExpTd = /<td[\s\S]+?<\/td\>/ig;

        //     // tables loop
        //     debugger;
        //     for (var i = 0; i < tablesArr.length; i++) {
        //         var table = tablesArr[i];
        //         var tableNew = '';
        //         var tblOpeningTag = table.match(regExpTr);
        //         var trsArr = table.match(regExpTr);
        //         if (!trsArr.length) {
        //             continue;
        //         }

        //         var tdsFromFirstTr = trsArr[0].match(regExpTd);
        //         // switch (tdsFromFirstTr.length) {
        //         //     case 1:
                        
        //         //         break;
        //         //     case 'Papayas':
        //         //         console.log('Mangoes and papayas are $2.79 a pound.');
        //         //         break;
        //         //     default:
        //         //         console.log(`Sorry, we are out of ${expr}.`);
        //         // }

        //         // two columns
        //         if (tdsFromFirstTr.length === 2) {
                    
        //         }

        //         // trs loop
        //         for (var j = 0; j < trsArr.length; j++) {
        //             var tr = trsArr[j];
        //             var trNew = '';
        //             var tdsArr = tr.match(regExpTd);
        //             if (tdsFromFirstTr.length === 2) {
        //                 // tdsArr[0]
        //             }
        //         }

        //         str = str.replace(table, tableNew);
        //     }

        //     return str;
        // },

        addThTags: function(str) {

            function replaceTdWithTh(td, additionalClassName) {
                if (td && td.parentNode){
                    var attrs = td.attributes;
                    var th = document.createElement('th');
                    for (var i = 0; i < attrs.length; i++) {
                        th.setAttribute(attrs[i].name, attrs[i].value);
                    }
                    th.classList.add('message-details__th');
                    if (additionalClassName) {
                        th.classList.add('message-details__th' + additionalClassName);
                    }
                    th.innerHTML = td.innerHTML;
                    if (th.innerText === 'Rollover/Carryover') {
                        th.classList.add('td__break-all');
                    }
                    if (th.innerHTML != '' ) { 
                        td.parentNode.replaceChild(th, td);
                    }
                    if (th.innerHTML === '') {
                        td.parentNode.remove(th, td)
                    }
                  
                }
            }

            function removeElem(elem) {
                if (elem && elem.parentNode){
                    elem.parentNode.removeChild(elem);
                }
            }

            // fix incorrect html by browser
            var div = document.createElement('div');
            var divInner = document.createElement('div');
            divInner.classList.add('message-details_sheet-inner');
            div.appendChild(divInner);
            divInner.innerHTML = str;

            // var tdLikeTh = div.querySelectorAll('td.mbi_text_bold');
            // for (var i = 0; i < tdLikeTh.length; i++) {
            //     tdLikeTh[i].classList.add('message-details__th');
            // }

            var removeUnnecessaryAttrs = true;
            var elementsToRemove = [];

            var tables = div.querySelectorAll('table');
            for (var i = 0; i < tables.length; i++) {
                var table = tables[i];

                if(i === 0) {
                    table.classList.add('header-line');
                }

                var tableTd = table.querySelectorAll('td');
                if (tableTd.length === 1 && !tableTd[0].querySelectorAll('span')) {
                    const h3 = document.createElement('h3');
                    h3.innerText = tableTd[0].innerText;
                    h3.classList.add('message-details_h3');
                    table.parentNode.insertBefore(h3, table);
                    elementsToRemove.push(table);
                    continue;
                }

                // table has subtables
                if (table.querySelectorAll('table').length) {
                    table.classList.add('table__has-subtables');
                    removeUnnecessaryAttrs = false;
                    continue;
                }

                var rows = table.querySelectorAll('tr');
                if (!rows.length) {
                    elementsToRemove.push(table);
                    continue;
                }

                var cellsLen = 0;
                for (var m = 0; m < rows.length; m++) {
                    var cells = rows[m].querySelectorAll('td');
                    cellsLen = Math.max(cellsLen, cells.length);
                }

                for (var j = 0; j < rows.length; j++) {
                    var row = rows[j];
                    var cells = row.querySelectorAll('td');
                    if (!cells.length) {
                        elementsToRemove.push(row);
                        continue;
                    }

                    if (cellsLen === 1) {
                        if (rows.length === 1) {
                            table.setAttribute('role', 'presentation');
                            continue;
                        }
                        for (var n = 0; n < cells.length; n++) {
                            if (cells[n].classList.contains('mbi_text_bold')) {
                                replaceTdWithTh(cells[n]);
                            }
                        }
                        continue;
                    }
                    if (cellsLen === 2) {
                        replaceTdWithTh(cells[0], '--hor');
                        continue;
                    }
                    if (cellsLen >= 3) {
                        if (rows.length === 1) {
                            continue;
                        }
                        if (!j) {
                            for (var k = 0; k < cells.length; k++) {
                                replaceTdWithTh(cells[k]);
                            }
                        }
                    }
                }
            }

            for (var i = 0; i < elementsToRemove.length; i++) {
                removeElem(elementsToRemove[i]);
            }

            // remove unnecessary attrs ("style", "<style>", etc)
            if (removeUnnecessaryAttrs) {
                divInner.innerHTML = $.cdh.helper.removeUnnecessaryAttrs(divInner.innerHTML);
            } else {
                // document.getElementById('message_details_sheet').classList.add('message-details_sheet--original-styles');
                divInner.classList.add('message-details_sheet-inner--original-styles');
            }

            return div.innerHTML;
        },

        overlayMiddleTables(str) {
            const div = document.createElement('div');
            div.innerHTML = str;

            const tables = div.querySelectorAll('table');
            tables.forEach(function(table, tablesIndex) {
                const trs = table.querySelectorAll('tr');
                if (!trs.length) return;

                const ths = trs[0].querySelectorAll('th');
                if (ths.length >= 5 && ths.length < 11) {
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('tbl__wrapper--scroll-x');
                    tables[tablesIndex].parentNode.insertBefore(wrapper, tables[tablesIndex]);
                    wrapper.appendChild(tables[tablesIndex]);
                }
            });

            return div.innerHTML;
        },

        rebuildBigTables(str) {
            const div = document.createElement('div');
            div.innerHTML = str;

            const tables = div.querySelectorAll('table');
            tables.forEach(function(table, tablesIndex) {
                const trs = table.querySelectorAll('tr');
                if (trs.length !== 2) return;
                
                const ths = trs[0].querySelectorAll('th');
                if (ths.length < 11) return;

                const newTbody = document.createElement('tbody');

                trs.forEach(function(tr, trIndex) {
                    if (!trIndex) return;

                    const rowTds = tr.querySelectorAll('td');
                    rowTds.forEach(function(td, tdIndex) {
                        const newTh = ths[tdIndex].cloneNode(true);
                        const newTd = td.cloneNode(true);
                        const newTr = document.createElement('tr');
                        newTr.appendChild(newTh);
                        newTr.appendChild(newTd);
                        newTbody.appendChild(newTr);
                    });
                });

                const newTable = document.createElement('table');
                newTable.appendChild(newTbody);

                tables[tablesIndex].innerHTML = newTable.innerHTML;
                tables[tablesIndex].classList.add('is-big-table');
            });

            return div.innerHTML;
        },
        
        hyphenationForLongWords: function (str) {
            const div = document.createElement('div');
            div.innerHTML = str;
            const tds = div.querySelectorAll('td');
            const regexp = /[a-z0-9_]{20,}/gi;
            for (let tdI = 0; tdI < tds.length; tdI++) {
                if (regexp.test(tds[tdI].innerText)) {
                    tds[tdI].classList.add('break-for-long-word');
                }
            }

            return div.innerHTML;
        },

        replaceBrs: function (str) {
            return str.replace(/<br\s*[\/]?\>([\s\n\r\t]*?<br\s*[\/]?\>[\s\n\r\t]*?){1,}/gi, '<br><br>');
        },

        replaceEmptyTdWithWhiteSpace: function (str) {
            return str.replace(/(<td[\s\S]*?>)\s*?&nbsp;\s*?(<\/td\>)/gi, '$1' + '-' + '$2');
        },

        replaceBWithStrong: function (str) {
            return str.replace(/\<b\>/gi, '<strong>')
                      .replace(/\<\/b\>/gi, '</strong>');
        },

        removeUnnecessaryAttrs: function (str) {
            // return str.replace(/class=\"[\s\S]*?\"/gi, '')
            //           .replace(/class=\'[\s\S]*?\'/gi, '')
            //           .replace(/style=\"[\s\S]*?\"/gi, '')
            //           .replace(/style=\'[\s\S]*?\'/gi, '')
            //           .replace(/\<style[\s\S]*?\<\/style\>/gi, '');
            return str.replace(/style=\"[\s\S]*?\"/gi, '')
                      .replace(/style=\'[\s\S]*?\'/gi, '')
                      .replace(/\<style[\s\S]*?\<\/style\>/gi, '');
        },

        isHtml: function(str) {
            var div = document.createElement('div');
            div.innerHTML = str;
            for (var i = 0, len = div.childNodes.length; i < len; i++) {
                if (div.childNodes[i].nodeType === 1) {
                    return true;
                }
            }
            return false;
        },

        // updateMagnificPopupBgHeight: function () {
        //     var paddingBottom = 20;
        //     var popupWrap = $('div.mfp-wrap');
        //     var popupContent = $('div.mfp-content');
        //     var popupBg = $('div.mfp-bg');
        //     var popupContentHeight = popupContent.outerHeight();
        //     var popupContentTop = parseInt(popupWrap.css('top'));

        //     popupBg.css({
        //         height: '100%'
        //     });
        //     var popupBgHeight = popupBg.outerHeight();

        //     if (popupContentHeight > (popupBgHeight - popupContentTop)) {
        //         popupBgHeight = (popupContentHeight + popupContentTop + paddingBottom) + 'px';
        //         popupBg.css({
        //             height: popupBgHeight
        //         });
        //     }
        // },

        titlePage: function(newHeader) {
            var popupHeaderVisible = $(".popup-form_title").is(":visible");
            var popupHeader = $(".popup-form_title");
            
            if(!newHeader){
                if(popupHeaderVisible){
                    return popupHeader.text().trim ();
                }else{
                    return $(".title-page").text().trim ();
                }
            }
            
            if(popupHeaderVisible){
                popupHeader.text(newHeader);
            } else {
                $(".title-page").text().trim ();
                $("#header-title").text(newHeader);
            }
        },
        
        titleStepModelHandler: function(stepModel, originalTitle){
            if(stepModel && stepModel.title){
                $.cdh.helper.titlePage(originalTitle + ' - ' + stepModel.title);
                return;
            }
            
            $.cdh.helper.titlePage(originalTitle);
        },

        title: function (title) {
            if (title)
                document.title = title + ' - ' + $.cdh.brand;
            else
                document.title = $.cdh.brand;
        },

        handleHeadingLevelOnPageStateChange: function(contentContainer, isPageOpen) {
            const $contentContainer = $(contentContainer);
            if($contentContainer.length === 0) return;

            const isUnsafeName = (name) => {
                return name.startsWith('aria-') || name === 'role'
            }
            const getUnsafeAttrs = (el) => {
                if(!el) return;
                const attrs = {};
                
                $.each(el.attributes, function() {
                    // this.attributes is not a plain object, but an array
                    // of attribute nodes, which contain both the name and value
                    if(this.specified && isUnsafeName(this.name)) {
                        attrs[this.name] = this.value;
                        console.log(this.name, this.value);
                    }
                });
                return attrs;
            }

            $contentContainer.find('[data-heading-level-on-page]').each(function() {
                const $el = $(this);
             
                const levelOnPage = $el.data('heading-level-on-page');
                const currentLevel = $el.attr('aria-level');
                const storedSign = 'stored-heading-level';
                const storedLevel = $el.data(storedSign);

                const $wrongClosest = $el.closest('[role="button"], [data-wrong-closest]').first();
                const hasWrongClosest = $wrongClosest.length > 0 && $contentContainer.find($wrongClosest).length > 0;
                const storedUnsafeAttrsSign = 'stored-unsafe-attrs';
                const wrongClosestHasStoredUnsafeAttrs = hasWrongClosest && $wrongClosest.data(storedUnsafeAttrsSign);

                if(isPageOpen) {
                    if(currentLevel) {
                        $el.data(storedSign, currentLevel);
                    }
                    if(levelOnPage === false) {
                        $el.removeAttr('aria-level role');
                    } else {
                        $el.attr({
                            'aria-level': levelOnPage,
                            'role': 'heading'
                        });
                    }

                    // If heading is present but is a descendant of one of the parents with wrong aria
                    // attributes, let store all aria attributes before cleanup
                    if(levelOnPage !== false && hasWrongClosest && !wrongClosestHasStoredUnsafeAttrs) {
                        const unsafeAttrsObjToRemove = getUnsafeAttrs($wrongClosest[0]);
                        $wrongClosest.removeAttr(Object.keys(unsafeAttrsObjToRemove).join(' '));
                        $wrongClosest.data(storedUnsafeAttrsSign, JSON.stringify(unsafeAttrsObjToRemove));
                        // if we remove wrongClosest selector, make sure to add another selector for restore later
                        $wrongClosest.attr('data-wrong-closest', true);
                    }

                } else {
                    if(storedLevel) {
                        $el.attr({
                            'aria-level': storedLevel,
                            'role': 'heading',
                        });
                    } else {
                        $el.removeAttr('aria-level role');
                    }

                    // restore aria attributes if needed
                    if(wrongClosestHasStoredUnsafeAttrs) {
                        $wrongClosest.attr(JSON.parse(wrongClosestHasStoredUnsafeAttrs));
                    }
                }
            })
        },
       

        removeWidget: function (widget) {
            var gridStack = $('.grid-stack').data('gridstack');
            if(widget.closest('.grid-stack .grid-stack-item')[0] !== undefined)
                gridStack.removeWidget(widget.closest('.grid-stack .grid-stack-item')[0]);
        },

        //get luma (from 0 to 100) of RGB color (ex. #ffffff)
        getLumaFromRGB: function getLumaFromRGB(colorRGB) {
            var colorRGB = colorRGB.replace('#','');      // strip # if any
            var rgb = parseInt(colorRGB, 16);   // convert rrggbb to decimal
            var r = (rgb >> 16) & 0xff;  // extract red
            var g = (rgb >> 8) & 0xff;  // extract green
            var b = (rgb >> 0) & 0xff;  // extract blue
            var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
            return luma;
        },

        // get iframe document
        getIframeDocument: function (iframe) {
            return iframe[0].contentWindow || (iframe[0].contentDocument.document || iframe[0].contentDocument);
        },

        // get iframe document element
        getIframeDocumentElement: function (iframe) {
            return iframe.contentDocument || iframe.contentWindow.document;
        },

        // update iframe height by content
        updateIframeHeightByContent: function (iframe) {
            var doc = this.getIframeDocument(iframe);
            var bodyHeight = $(doc.document.body).outerHeight() + 18; // margin protection
            iframe.height(bodyHeight + 'px');
        },

        // set iframe content
        setIframeContent: function(iframe, text) {
            var doc = this.getIframeDocument(iframe);
            doc.document.open();
            doc.document.write(text);
            doc.document.close();
        },

        // scroll page to content top
        scrollPageToContentTop: function(callback) {
            var headerHeight = $('header.header').outerHeight();
            var contentTop = $('div.content').offset().top;
            $('html, body').animate({
                scrollTop: contentTop - headerHeight
            }, 300, function() {
                if (typeof callback === 'function') {
                    callback();
                }
            });
        },

        // scroll page to top
        scrollPageToTop: function() {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        },

        // scroll page to element (considering fixed header)
        scrollPageToElement: function(elem, callback) {
            var headerHeight = $('header.header').outerHeight();
            if (!elem.length) {
                return;
            }

            elem.each(function() {
                if (this.nodeType !== 1) {
                    return;
                }

                var elemTop = $(this).offset().top;
                $('html, body').animate({
                    scrollTop: elemTop - headerHeight
                }, 300, function() {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        },

        // scroll page to iframe top
        scrollPageToIframeTop: function(iframe) {
            $.cdh.helper.scrollPageToElement(iframe);
        },

        // remove milliseconds from date
        removeMillisecondsFromDate: function(date) {
            if (typeof date !== 'string') {
                return date;
            }

            if (date.indexOf('.') != -1) {
                var dateArr = date.split('.');
                if (dateArr.length === 2) {
                    date = dateArr[0];
                }
            }
            return date;
        },

        // is value set
        isValueSet: function (value) {
            return value !== undefined && value !== null && value !== '';
        },

        // set video iframe ratio
        setVideoIframeRatio: function(iframe) {

            // get iframe parent
            var iframeParent = iframe.parent();

            // exit if video-iframe-wrapper already exists
            if (iframeParent.hasClass('video-iframe-wrapper')) {
                return;
            }

            // get iframe width and height
            var width = iframe.attr('width');
            var height = iframe.attr('height');

            // exit if attributes don't exist
            if (!width || !height) {
                return;
            }

            // add iframe parent and set his ratio
            var ratio = height * 100 / width;
            ratio = Math.round(ratio * 100) / 100;
            iframe.wrap('<div class="video-iframe-wrapper" style="padding-bottom: ' + ratio + '%;"></div>');
        },

        // set all video iframes ratio
        setAllVideoIframesRatio: function() {

            // list of iframes with video
            var videoIframesSelectors = [
                '.announce-item',
                '.b-forms_documents_item',
                '.faq-item',
                '.cms-announcement-content'
            ];

            var self = this;
            for (var i = 0, len = videoIframesSelectors.length; i < len; i++) {
                $(videoIframesSelectors[i]).find('iframe').each(function() {
                    self.setVideoIframeRatio($(this));
                });
            }
        },

        // html encode
        htmlEncode: function (str) {
            if (str) {
                return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
                    .replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }
            return str;
        },

        // html decode
        htmlDecode: function(input) {
            if (input) {
                const doc = new DOMParser().parseFromString(input, "text/html");
                return doc.documentElement.textContent;
            }
            return input;
        },

        // remove gridstack absolute position and fixed height if there is one widget on the page
        removeGridstackFixedHeight: function(widgetsLen) {

            // exit if there are more than one widget on the page
            if (widgetsLen > 1) {

                // WCP-5329: added additional height check for slow computers and internet.
                function startMiddleChecks() {
                    var checksNumMiddle = 5;
                    var checkDelayMiddle = 1000;
                    var intervalMiddle = setInterval(function() {
                        fixWidgetsContainerHeight();
                        if (!(--checksNumMiddle)) {
                            clearInterval(intervalMiddle);
                            startSlowChecks();
                        }
                    }, checkDelayMiddle);
                }

                function startSlowChecks() {
                    var checksNumSlow = 15;
                    var checkDelaySlow = 3000;
                    var intervalSlow = setInterval(function() {
                        fixWidgetsContainerHeight();
                        if (!(--checksNumSlow)) {
                            clearInterval(intervalSlow);
                        }
                    }, checkDelaySlow);
                }

                var checksNumFast = 20;
                var checkDelayFast = 250;
                var intervalFast = setInterval(function() {
                    fixWidgetsContainerHeight();
                    if (!(--checksNumFast)) {
                        clearInterval(intervalFast);
                        startMiddleChecks();
                    }
                }, checkDelayFast);


                // exit
                return;
            }

            var mainContent = $('#main-content');

            // correct widgets with 100%-height
            mainContent.find('[data-skip-fix-widget-height]').each(function() {
                var elem = $(this);
                if (elem.data('skip-fix-widget-height') === true) {
                    elem.css({
                        height: elem.outerHeight()
                    });
                }
            });

            // add grid-stack class name
            setTimeout(function() {
                mainContent.addClass('grid-stack-height-auto');
            }, 0);
        },

        // transform currency supper
        transformCurrencySupper: function(val) {
            var currency = $.cdh.helper.parseCurrency(val);
            var html = '$' + currency.beforeDot + '.' + currency.afterDot;
            if (currency.negative) {
                html = "(" + html + ")";
            }
            return '<span>' + html + '</span>';
        },

        // build contribution chart labels
        buildContributionChartLabels: function(element, chartData, additionalData) {
            var $g = $(element).find('g:last');
            var $rTop = $g.find('rect:last');
            var $rBottom = $g.find('rect:first');
            var topTextY = 'auto';
            var bottomTextY = 'auto';
            var topTextOffsetClassName = '';
            var bottomTextOffsetClassName = '';
            var textX = $rTop.attr('x');

            var valuesData = null;
            var topValueName = '';
            var bottomValueName = '';
            var topValue = '';
            var bottomValue = '';

            if (typeof(chartData) && 'extendSettings' in chartData) {
                valuesData = chartData.extendSettings.seriesGroups[0].series;
                topValueName = valuesData[1].dataField;
                bottomValueName = valuesData[0].dataField;
                topValue = chartData.dataArr[0][topValueName];
                bottomValue = chartData.dataArr[0][bottomValueName];
            } else if (typeof(additionalData) === 'object') {
                topValue = additionalData.topValue;
                bottomValue = additionalData.bottomValue;
            }

            // calculate coordinates
            var topOffsetClassName = 'mod_top-offset';
            if (topValue >= 0) {
                topTextY = $rTop.attr('y');
                bottomTextY = parseInt($rBottom.attr('y'), 10) + parseInt($rBottom.attr('height'), 10);
                bottomTextOffsetClassName = topOffsetClassName;
            } else {
                topTextY = parseInt($rTop.attr('y'), 10) + parseInt($rTop.attr('height'), 10);
                bottomTextY = $rBottom.attr('y');
                topTextOffsetClassName = topOffsetClassName;
            }

            /* change text color to white on chart columns if background is too dark */
            var topTextLumaClassName = '';
            var bottomTextLumaClassName = '';
            var colorScheme = $.jqx._jqxChart.prototype.colorSchemes.filter(function(item) {
                return item.name === chartData.colorScheme;
            });
            if (typeof(colorScheme) === 'object' && colorScheme.length) {
                var lightLuma = 170;
                var topLuma = $.cdh.helper.getLumaFromRGB(colorScheme[0].colors[1]);
                var bottomLuma = $.cdh.helper.getLumaFromRGB(colorScheme[0].colors[0]);

                // correct luma if on of the values is 0
                if (!topValue && !bottomValue) {
                    topLuma = lightLuma;
                    bottomLuma = lightLuma;
                } else {
                    if (!topValue) {
                        topLuma = bottomLuma;
                    }
                    if (!bottomValue) {
                        bottomLuma = topLuma;
                    }
                }

                var modLightClassName = 'mod_light';
                if (topLuma < lightLuma) {
                    topTextLumaClassName = modLightClassName;
                }
                if (bottomLuma < lightLuma) {
                    bottomTextLumaClassName = modLightClassName;
                }
            }

            // create text elements
            var baseClassName = 'account-balance_chart-h account-contribution-text';
            $(element).append(
                '<div class="' + baseClassName + ' ' + topTextOffsetClassName + ' ' + topTextLumaClassName + '" ' +
                    'style="left:' + textX + 'px; ' +
                           'top:' + topTextY + 'px;">' +
                    $.cdh.helper.transformCurrencySupper(topValue) +
                '</div>');
            $(element).append(
                '<div class="' + baseClassName + ' ' + bottomTextOffsetClassName + ' ' + bottomTextLumaClassName + '" '+
                    'style="left:' + textX + 'px; ' +
                           'top:' + bottomTextY + 'px;">' +
                    $.cdh.helper.transformCurrencySupper(bottomValue) +
                '</div>');
        },

        addTabSwitchForRadioButtons: function(parentSelector, radioSelector) {
            var parent = $(parentSelector);
            var isAddedName = 'radio-buttons-tab-switch';
            if (parent.data(isAddedName) == 1) {
                return;
            }

            parent.data(isAddedName, 1);
            var radioButtons = parent.find(radioSelector);
            radioButtons.each(function() {
                $(this).keydown(function(e) {
                    if (e.keyCode !== 9) {
                        return;
                    }

                    var currentRadioButtonIndex = radioButtons.index(this);
                    if (currentRadioButtonIndex < (radioButtons.length - 1)) {
                        e.preventDefault();
                        radioButtons[currentRadioButtonIndex + 1].focus();
                    }
                });
            });
        },

        addKeyboardNavToMenu: function(menuSelector, itemsSelector) {
            var menu = $(menuSelector);
            var items = menu.find(itemsSelector);
            items.each(function() {
                $(this).attr('tabindex', '-1');
                $(this).keydown(function(e) {                    
                    if (e.keyCode === 38 || e.keyCode === 37 || e.keyCode === 40 || e.keyCode === 39) {
                        var index = menu.find(itemsSelector).index($(this));
                        if (e.keyCode === 38 || e.keyCode === 37) {
                            e.preventDefault();
                            if (--index === -1) {
                                index = items.length - 1;
                            }
                        }
                        if (e.keyCode === 40 || e.keyCode === 39) {
                            e.preventDefault();
                            if (++index === items.length) {
                                index = 0;
                            }
                        }
                        $(this).attr('tabindex', '-1');
                        $(items[index]).attr('tabindex', '0').focus();
                    }

                    if (e.keyCode === 13 || e.keyCode === 32) {
                        e.preventDefault();
                        e.target.click();
                    }

                    if(e.keyCode === 9) {
                        if ($(this).attr('role') !== 'menuitemradio') {
                            menu.trigger('exit');
                        }
                    }
                });
            });
            $(items[0]).attr('tabindex', '0');
        },

        addKeyboardNavForCheckboxesWithHint: function () {
            var className = {
                focused: 'ch-item--hint--focused',
                focusAdded: 'ch-item--hint--focus-added'
            };

            function showHint(elem) {
                elem.closest('div.ch-item--hint').addClass(className.focused);
            }
            function hideHint(elem) {
                elem.closest('div.ch-item--hint').removeClass(className.focused);
            }

            $('div.ch-item--hint:not(.' + className.focusAdded + ')').find('input').each(function() {
                $(this).closest('div.ch-item--hint').addClass(className.focusAdded);
                $(this).on('focus', function() {
                    showHint($(this));
                });
                $(this).on('blur', function() {
                    hideHint($(this));
                });
                $(this).keydown(function(e) {
                    if (e.keyCode === 27) {
                        hideHint($(this));
                    }
                });
            });
        },

        initTabsNavigation: function (tabsRootEl, options) {
            var defaultOptions = {
                changeTabindex: true,
                changeAriaSelected: true,
            }

            var options = Object.assign({}, defaultOptions, (options || {}));

            var tabsRootEl = typeof tabsRootEl === 'string' ? document.querySelector(tabsRootEl) : tabsRootEl;
            if (!tabsRootEl) {
                console.error('Wrong tabsRootEl in `initTabsNavigation`');
                return;
            }
            var tablist = tabsRootEl.querySelectorAll('[role="tablist"]')[0];
            var tabs;
            var panels;

            generateArrays();

            function generateArrays() {
                tabs = tabsRootEl.querySelectorAll('[role="tab"]');
                panels = tabsRootEl.querySelectorAll('[role="tabpanel"]');
            };

            // For easy reference
            var keys = {
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46,
                enter: 13,
                space: 32
            };

            // Add or subtract depending on key pressed
            var direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1
            };

            // Bind listeners
            for (let i = 0; i < tabs.length; ++i) {
                addListeners(i);
            };

            function addListeners(index) {
                tabs[index].addEventListener('click', clickEventListener);
                tabs[index].addEventListener('keydown', keydownEventListener);
                tabs[index].addEventListener('keyup', keyupEventListener);

                // Optional custom event (we use jQuery here as crossbrowser solution)
                $(tabs[index]).on('activateTab', clickEventListener);

                // Build an array with all tabs (<button>s) in it
                tabs[index].index = index;
            };

            // When a tab is clicked, activateTab is fired to activate it
            function clickEventListener(event) {
                var tab = event.currentTarget;
                activateTab(tab, { setFocus: false });
            };

            // Handle keydown on tabs
            function keydownEventListener(event) {
                var key = event.keyCode;

                switch (key) {
                    case keys.end:
                        event.preventDefault();
                        // Activate last tab
                        focusLastTab();
                        break;
                    case keys.home:
                        event.preventDefault();
                        // Activate first tab
                        focusFirstTab();
                        break;

                    // Up and down are in keydown
                    // because we need to prevent page scroll >:)
                    case keys.up:
                    case keys.down:
                        determineOrientation(event);
                        break;
                };
            };

            // Handle keyup on tabs
            function keyupEventListener(event) {
                var key = event.keyCode;

                switch (key) {
                    case keys.left:
                    case keys.right:
                        determineOrientation(event);
                        break;
                    case keys.enter:
                    case keys.space:
                        activateTab(event.target);
                        break;
                };
            };

            // When a tablist's aria-orientation is set to vertical,
            // only up and down arrow should function.
            // In all other cases only left and right arrow function.
            function determineOrientation(event) {
                var key = event.keyCode;
                var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
                var proceed = false;

                if (vertical) {
                    if (key === keys.up || key === keys.down) {
                        event.preventDefault();
                        proceed = true;
                    };
                }
                else {
                    if (key === keys.left || key === keys.right) {
                        proceed = true;
                    };
                };

                if (proceed) {
                    switchTabOnArrowPress(event);
                };
            };

            // Either focus the next, previous, first, or last tab
            // depending on key pressed
            function switchTabOnArrowPress(event) {
                var pressed = event.keyCode;

                if (direction[pressed]) {
                    var target = event.target;
                    if (target.index !== undefined) {
                        if (tabs[target.index + direction[pressed]]) {
                            tabs[target.index + direction[pressed]].focus();
                        }
                        else if (pressed === keys.left || pressed === keys.up) {
                            focusLastTab();
                        }
                        else if (pressed === keys.right || pressed === keys.down) {
                            focusFirstTab();
                        };
                    };
                };
            };

            // Activates any given tab panel
            function activateTab(tab, config) {
                var defaults = {
                    setFocus: true,
                }
                var params = Object.assign({}, defaults, (config || {}));

                // // Deactivate all other tabs
                deactivateTabs();

                if (options.changeTabindex) {
                    // Remove tabindex attribute or add value 0 (for non-interactive elements)
                    // tab.removeAttribute('tabindex');
                    tab.setAttribute('tabindex', '0');
                }

                if (options.changeAriaSelected) {
                    // Set the tab as selected
                    tab.setAttribute('aria-selected', 'true');
                }

                // Get the value of aria-controls (which is an ID)
                // var controls = tab.getAttribute('aria-controls');

                // // Remove hidden attribute from tab panel to make it visible
                // document.getElementById(controls).removeAttribute('hidden');

                // Set focus when required
                if (params.setFocus) {
                    tab.focus();
                };
            };

            // // Deactivate all tabs and tab panels
            function deactivateTabs() {
                for (t = 0; t < tabs.length; t++) {
                    if (options.changeTabindex) {
                        tabs[t].setAttribute('tabindex', '-1');
                    }
                    if (options.changeAriaSelected) {
                        tabs[t].setAttribute('aria-selected', 'false');
                    }
                };

                // for (p = 0; p < panels.length; p++) {
                //     panels[p].setAttribute('hidden', 'hidden');
                // };
            };

            // Make a guess
            function focusFirstTab() {
                tabs[0].focus();
            };

            // Make a guess
            function focusLastTab() {
                tabs[tabs.length - 1].focus();
            };
        },

        initMenuAccesibility: function (menuList, options) {
            var defaultOptions = {
                changeTabindex: true,
            }

            var options = Object.assign({}, defaultOptions, (options || {}));
            
            const $menuList = $(menuList);
            const $listItems = $menuList.find("> li");

            $listItems.each(function(){
                const $el = $(this);
                const elIndex = $listItems.index($el);
                const $radio = $el.find('input[type="radio"]');
                const $anchorOrButton = $el.find('a, button').not('[role]');

                $el.attr({
                    role: 'none',
                });

                [$radio, $anchorOrButton].filter(Boolean).forEach($elem => {
                    $elem.attr({
                        role: $elem.is($radio) ? 'menuitemradio' : 'menuitem',
                    });
                    if (options.changeTabindex) {
                        $elem.attr('tabindex', elIndex === 0 ? 0 : -1);
                    }
                })
            })
           
        },

        initMenuNavigation: function (menuList, options) {
            var defaultOptions = {
                changeTabindex: true,
            }

            var options = Object.assign({}, defaultOptions, (options || {}));

            var menuList = typeof menuList === 'string' ? document.querySelector(menuList) : menuList;
            if (!menuList) {
                console.error('Wrong menuList in `initMenuNavigation`');
                return;
            }

            let menuItems;

            generateArrays();

            function generateArrays() {
                menuItems = menuList.querySelectorAll('[role="menuitem"], [role="menuitemradio"]');
            };

            // For easy reference
            const keys = {
                tab: 9,
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46,
                enter: 13,
                space: 32
            };

            // Add or subtract depending on key pressed
            const direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1
            };

            // Bind listeners
            for (let i = 0; i < menuItems.length; ++i) {
                addListeners(i);
            };

            function addListeners(index) {
                menuItems[index].addEventListener('click', clickEventListener);
                menuItems[index].addEventListener('keydown', keydownEventListener);
                menuItems[index].addEventListener('keyup', keyupEventListener);

                // Build an array with all menuItems (<button>s) in it
                menuItems[index].index = index;
            };

            // When a menuItem is clicked, activateMenuItem is fired to activate it
            function clickEventListener(event) {
                var menuItem = event.currentTarget;
                activateMenuItem(menuItem, { setFocus: false });
            };


            // Handle keydown on menu
            function keydownEventListener(event) {
                var key = event.keyCode;

                switch (key) {
                    case keys.end:
                        event.preventDefault();
                        // Activate last menu item
                        focusLastMenuItem();
                        break;
                    case keys.home:
                        event.preventDefault();
                        // Activate first menu item
                        focusFirstMenuItem();
                        break;
                    case keys.tab:
                        handleExit(event);
                        break;
                    // Up and down are in keydown
                    // because we need to prevent page scroll >:)
                    case keys.up:
                    case keys.down:
                        determineOrientation(event);
                        break;
                };
            };

            // Handle keyup on menuItems
            function keyupEventListener(event) {
                var key = event.keyCode;

                switch (key) {
                    
                    case keys.left:
                    case keys.right:
                        determineOrientation(event);
                        break;
                    case keys.enter:
                    case keys.space:
                        activateMenuItem(event.target);
                        break;
                };
            };

            // When a menuList's aria-orientation is set to vertical,
            // only up and down arrow should function.
            // In all other cases only left and right arrow function.
            function determineOrientation(event) {
                var key = event.keyCode;
                var horizontal = menuList.getAttribute('aria-orientation') === 'horizontal';
                var proceed = false;
                
                if (horizontal) {
                    if (key === keys.left || key === keys.right) {
                        proceed = true;
                    };
                } else {
                    if (key === keys.up || key === keys.down) {
                        event.preventDefault();
                        proceed = true;
                    };
                }

                if (proceed) {
                    switchMenuItemOnArrowPress(event);
                };
            };

            // Either focus the next, previous, first, or last tab
            // depending on key pressed
            function switchMenuItemOnArrowPress(event) {
                var pressed = event.keyCode;
                if (direction[pressed]) {
                    var target = event.target;
                    if (target.index !== undefined) {
                        if (menuItems[target.index + direction[pressed]]) {
                            activateMenuItem(menuItems[target.index + direction[pressed]])
                            // menuItems[target.index + direction[pressed]].focus();
                        }
                        else if (pressed === keys.left || pressed === keys.up) {
                            activateMenuItem(menuItems[menuItems.length - 1]);
                            // focusLastMenuItem();
                        }
                        else if (pressed === keys.right || pressed === keys.down) {
                            activateMenuItem(menuItems[0]);
                            // focusFirstMenuItem();
                        };
                    };
                };
            };

            // Activates any given tab panel
            function activateMenuItem(menuItem, config) {
                var defaults = {
                    setFocus: true,
                }
                var params = Object.assign({}, defaults, (config || {}));

                // Deactivate all menuItems
                deactivateMenuItems();

                if (options.changeTabindex) {
                    // Remove tabindex attribute or add value 0 (for non-interactive elements)
                    // tab.removeAttribute('tabindex');
                    menuItem.setAttribute('tabindex', '0');
                }

                // Set focus when required
                if (params.setFocus) {
                    menuItem.focus();
                };
            };

            // // Deactivate all tabs and tab panels
            function deactivateMenuItems() {
                for (t = 0; t < menuItems.length; t++) {
                    if (options.changeTabindex) {
                        menuItems[t].setAttribute('tabindex', '-1');
                    }
                };

                // for (p = 0; p < panels.length; p++) {
                //     panels[p].setAttribute('hidden', 'hidden');
                // };
            };

            // Make a guess
            function focusFirstMenuItem() {
                menuItems[0].focus();
            };

            // Make a guess
            function focusLastMenuItem() {
                menuItems[menuItems.length - 1].focus();
            };

            // Handle events on menuList
            function handleExit(e){
                if ($(e.target).attr('role') === 'menuitemradio') {
                    return;
                }
                $(menuList).trigger('exit');
            }
        },

        setChartAttrs(chartDiv) {
            // NOTE: Do not use this code because some charts can be invisible on init (desktop/mobile),
            //       and attributes changes will not be applied.
            //       Also the chart is completely redrawn when the window is resized.
            // if (chartDiv.data('attrs-ready')) {
            //     return;
            // }
            chartDiv.find('.tblChart').attr('role', 'presentation');
            const svg = chartDiv.find('svg');
            svg.removeAttr('id').attr('role', 'img');
            const chartAlt = chartDiv.data('chart-alt');
            if (chartAlt) {
                svg.attr('aria-label', chartAlt);
            }
            chartDiv.removeData('chart-alt');
        },

        makeTagPattern(color, index) {
            const id = "patternId" + Math.random().toString(16).slice(2);
            const patterns = [
                '<pattern id="' + id + '" patternUnits="userSpaceOnUse" viewBox="0,0,5,5" width="5" height="5"><rect x="0" y="0" width="5" height="5" fill="' + color + '" /><line x1="0" y1="0" x2="0" y2="5" stroke="#fff" stroke-width="1" stroke-opacity="0.5" /><line x1="0" y1="5" x2="5" y2="5" stroke="#fff" stroke-width="1" stroke-opacity="0.5" /></pattern>',
                '<pattern id="' + id + '" patternUnits="userSpaceOnUse" viewBox="0,0,5,5" width="5" height="5"><rect x="0" y="0" width="5" height="5" fill="' + color + '" /><line x1="5" y1="5" x2="0" y2="0" stroke="#fff" stroke-width="1" stroke-opacity="0.5" /></pattern>',
                '<pattern id="' + id + '" patternUnits="userSpaceOnUse" viewBox="0,0,5,5" width="5" height="5"><rect x="0" y="0" width="5" height="5" fill="' + color + '" /><line x1="0" y1="5" x2="5" y2="0" stroke="#fff" stroke-width="1" stroke-opacity="0.5" /></pattern>',
                '<pattern id="' + id + '" patternUnits="userSpaceOnUse" viewBox="0,0,5,5" width="5" height="5"><rect x="0" y="0" width="5" height="5" fill="' + color + '" /><line x1="0" y1="5" x2="5" y2="0" stroke="#fff" stroke-width="1" stroke-opacity="0.5" /><line x1="5" y1="5" x2="0" y2="0" stroke="#fff" stroke-width="1" stroke-opacity="0.5" /></pattern>',
            ];

            return patterns[index];
        },

        makePathPattern(path, patternKey) {
            if (!path) return;
            const svg = path.closest('svg');            
            const defs = svg.querySelector('defs');
            
            if (path.hasAttribute('fill')) {
                let color = path.getAttribute('fill');
                if (color.includes('url')) {
                    path.setAttribute('fill', color);
                    path.setAttribute('data-fill', color);
                }
                else {
                    const pattern = $.cdh.helper.makeTagPattern(color, patternKey);
                    const patternId = $(pattern).attr('id');
                    const fillInner = 'url(#' + patternId + ')';

                    defs.innerHTML += pattern;
                    path.setAttribute('fill', fillInner);
                    path.setAttribute('data-fill', fillInner);
                }
            }
        },

        makePatternSvg(pattern) {
            const patternId = $(pattern).attr('id');
            let svg = '<svg version="1.1" width="100%" height="100%" overflow="hidden" aria-hidden="true" role="img">';
            svg += '<defs>' + pattern + '</defs>';
            svg += '<rect x="0" y="0" width="2.214rem" height="2.214rem" fill="url(#' + patternId + ')"></rect>';
            svg += '</svg>';

            return svg;
        },

        getPageTitleData() {
            const sep = '|';
            const titleArr = document.title.split(sep);
            let title = '';
            let customer = '';
            if (titleArr.length === 2) {
                title = $.trim(titleArr[0]);
                customer = $.trim(titleArr[1]);
            }
            if (titleArr.length === 1) {
                customer = $.trim(titleArr[0]);
            }
            return {
                title: title,
                customer: customer,
                sep: sep
            };
        },

        replacePageTitle(title) {
            const titleData = $.cdh.helper.getPageTitleData();
            let pageTitle = title;
            if (titleData.customer) {
                pageTitle += ' ' + titleData.sep + ' ' + titleData.customer;
            }
            document.title = pageTitle;
        },        

        makeAvailableDependentItem(focusOnFirstElement = false) {
            var breakPoint = 768;
            var mainEls = document.getElementsByClassName('profile-wrap');
            if (mainEls) {
                var attributesManager = function (isAdd) {
                    for (var i = 0; i < mainEls.length; i++) {
                        var buttonEl = mainEls[i].getElementsByClassName('info clearfix')[0];
                        if (isAdd) {
                            buttonEl.setAttribute('tabindex', '0');
                            buttonEl.setAttribute('role', 'button');
                        } else {
                            buttonEl.removeAttribute('tabindex');
                            buttonEl.removeAttribute('aria-expanded');
                            buttonEl.removeAttribute('role');
                        }
                    }
                };
                var buttonWasHidden = false;

                window.addEventListener('resize', _.debounce(function (e) {
                    if (e.target.innerWidth < breakPoint && !buttonWasHidden) {
                        attributesManager(true);
                        buttonWasHidden = true;
                    } else if (e.target.innerWidth >= breakPoint && buttonWasHidden) {
                        attributesManager(false);
                        buttonWasHidden = false;
                    }
                }));
                if (focusOnFirstElement) {
                    setTimeout(function () {
                        if (window.innerWidth < breakPoint) {
                            mainEls[0].querySelector('.info').focus();
                        } else {
                            mainEls[0].querySelector('button').focus();
                        }
                    }, 100);
                }
            }

            setTimeout(function () {
                attributesManager(window.innerWidth < breakPoint);
            });
        },
        maskAccountRoutingNumbers: function (value) {
            const numbersToShow = 4;
            const numbersToMak = 4;
            var maskedDigits = '*'.repeat(numbersToMak);
            if ($.type(value) === 'string') {
                if (value.length == numbersToShow) {
                    value = maskedDigits + value;
                }
                else if (value.length > 4) {
                    var sliceLastDigits = value.substr(value.length - numbersToShow);
                    value = maskedDigits + sliceLastDigits;
                }
            }
            return value;
        },
        maskPhoneNumber: function (phoneNumber) {
        
            if ((phoneNumber == undefined || phoneNumber == null || phoneNumber == '') || phoneNumber.length <= 4) {
                return phoneNumber;
            }

            const numbersToMak = 3;
            const lastFourDigits = 4;

            const result = '*'.repeat(numbersToMak) + "-" + '*'.repeat(numbersToMak) + "-" + phoneNumber.substr(phoneNumber.length - lastFourDigits);

            return result;
        },

        spiltMobileNumber: function (phoneNumber) {
            if (!phoneNumber || typeof phoneNumber !== 'string') {
                return phoneNumber;
            }
            var digitsOnly = phoneNumber.replace(/\D/g, '');
            if (digitsOnly.length < 10) {
                return phoneNumber;
            }
            if (digitsOnly.length > 10) digitsOnly = digitsOnly.substring(1);
            const part1 = digitsOnly.substring(0, 3);
            const part2 = digitsOnly.substring(3, 6);
            const part3 = digitsOnly.substring(6, 10);

            return `+1 ${part1}-${part2}-${part3}`;
        }
    };

    function removeChatHistory() {
        Object.keys(localStorage).forEach(key => {
            if (key.indexOf('_act') != -1)
                localStorage.removeItem(key);
        });
    }


    $.extend(true, $, {
        cdh: {
            helper: helper
        }
    });
})(jQuery);